module.exports = __webpack_public_path__ + "static/media/top-venues-video.31fdc607.mp4";